/**
 * Location state of navigations the app starts itself once the session or a server is gone (sign out, an
 * expired session, a removed server). Leave guards let these through: the draft they protect can no longer be
 * applied.
 */
export const UNGUARDED_NAVIGATION = { unguarded: true } as const;

export function isUnguardedNavigation(location: { state: unknown }): boolean {
  const { state } = location;
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { unguarded?: unknown }).unguarded === true
  );
}
